<template>
    <div>
        <section>
            <div class="inner row5">
                <article class="loginInner">
                    <h1>휴대폰 인증</h1>
                    <div class="aRow5">
                        <p>
                            가입되어 있는 휴대폰 번호를 입력해 주세요.
                        </p>
                    </div>

                    <form @submit.prevent="onClickLogin" class="aRow5">
                        <div class="inputBox">
                            <label>휴대폰 번호</label>
                            <input id='id' v-model="id">
                            <input type="button" class="mobileAuthBtn" value="인증번호 받기">
                        </div>
                        <div class="inputBox">
                            <label>인증번호 6자리 입력 </label>
                            <input id='pw' type="password" v-model="pw">
                        </div>
                        <div class="inputBtnBox">
                            <input type="submit" value="비밀번호 재설정">
                            <router-link to="/auth"><span class="joinTxt nomargin"><strong>로그인으로 돌아가기</strong></span></router-link>
                        </div>
                    </form>
                </article>
            </div>
        </section> 
    </div>   
</template>

<script>
export default {
  name: 'MobileAuth',
  props: {
    redirect:{
      type: String
    }
  },
  data(){
    return{
      id: "",
      pw: ""
    }
  },
  methods:{
    onClickLogin() {
      console.log("[onClickLogin] username: " + this.id + " password: " + this.pw)

      this.$router.replace({
        path: "/"
      })
    }
  }
}
</script>

<style scoped>
  .loginInner > h1 {
    color: #9E1915;
  }
</style>